import { render, staticRenderFns } from "./PlanChip.vue?vue&type=template&id=65aafb58&"
import script from "./PlanChip.vue?vue&type=script&lang=js&"
export * from "./PlanChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports